export default "__VITE_ASSET__5ef7b918__"